module.exports = "<router-outlet>\n  <div class=\"notifier\">\n    <notifier-container></notifier-container>\n  </div>\n</router-outlet>\n"